import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from "react";
import { utils } from '../Utils/Utils';
import { VideoStreamRenderer } from "@azure/communication-calling";
import CustomVideoEffects from "./RawVideoAccess/CustomVideoEffects";
import VideoReceiveStats from './VideoReceiveStats';
import RemoteParticipantCard from "./RemoteParticipantCard";
import { Avatar, Col, Row } from "antd";
import LocalVideoPreviewCard from "./LocalVideoPreviewCard";

export const FunctionalStreamRenderer = forwardRef(({ data, isvideoOn, selectedCameraDeviceId, showLocalVideo, deviceManager, UserProfileName, remoteParticipants, remoteParticipant, stream, dominantRemoteParticipant, dominantSpeakerMode, call, updateStreamList, maximumNumberOfRenderers }, ref) => {
    const componentId = `${utils.getIdentifierText(remoteParticipant.identifier)}-${stream.mediaStreamType}-${stream.id}`;
    const videoContainerId = componentId + '-videoContainer';
    const componentContainer = useRef(null);

    const videoContainer = useRef(null);
    const [renderer, setRenderer] = useState();
    const [view, setView] = useState();
    const [isLoading, setIsLoading] = useState(true);
    // const [isvideoOn, setIsVedioOn] = useState();
    const [isSpeaking, setIsSpeaking] = useState((remoteParticipant && remoteParticipant.isSpeaking));
    const [isMuted, setIsMuted] = useState((remoteParticipant && remoteParticipant.isMuted));
    const [displayName, setDisplayName] = useState((remoteParticipant && remoteParticipant.displayName && remoteParticipant.displayName.trim()) && '');
    const [videoStats, setVideoStats] = useState();
    useEffect(() => {
        initializeComponent();
        return () => {
            disposeRenderer();
            stream.off('isReceivingChanged', isReceivingChanged);
            stream.off('isAvailableChanged', isAvailableChanged);
            remoteParticipant.off('isSpeakingChanged', isSpeakingChanged);
            remoteParticipant.off('isMutedChanged', isMutedChanged);
            remoteParticipant.off('displayNameChanged', isDisplayNameChanged);
        }
    }, []);

    useEffect(() => {
        const createView = async () => {
            if (renderer) {
                const createdView = await renderer.createView();
                setView(createdView);
            }
        };
        createView();
    }, [renderer]);

    useEffect(() => {
        if (view) {
            attachRenderer();
        }
    }, [view]);

    const createRenderer = () => {
        if (!renderer) {
            const videoRenderer = new VideoStreamRenderer(stream);
            setRenderer(videoRenderer);
        } else {
            throw new Error(`[App][StreamMedia][id=${stream.id}][createRenderer] stream already has a renderer`);
        }
    }

    const attachRenderer = () => {
        try {
            if (!view.target) {
                throw new Error(`[App][StreamMedia][id=${stream.id}][attachRenderer] target is undefined. Must create renderer first`);
            } else {
                // componentContainer.current.hidden = false;
                videoContainer.current.appendChild(view && view.target);
            }
        } catch (e) {
            console.error(e);
        }
    }

    const disposeRenderer = () => {
        if (videoContainer.current && componentContainer.current) {
            videoContainer.current.innerHTML = '';
            // componentContainer.current.hidden = true;
        }

        if (renderer) {
            renderer.dispose();
        } else {
            console.warn(`[App][StreamMedia][id=${stream.id}][disposeRender] no renderer to dispose`);
        }
    }
    const isReceivingChanged = () => {
        try {
            if (stream.isAvailable) {
                const isReceiving = stream.isReceiving;
                if (!isReceiving && !isLoading) {
                    setIsLoading(true)
                } else if (isReceiving && isLoading) {
                    setIsLoading(false);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    const isAvailableChanged = async () => {
        try {
            if (dominantSpeakerMode && dominantRemoteParticipant !== remoteParticipant) {
                return;
            }
            if (call.activeRemoteVideoStreamViews && call.activeRemoteVideoStreamViews.size >= maximumNumberOfRenderers && !stream.isAvailable) {
                updateStreamList();
            }
            if (stream.isAvailable && !renderer) {
                if (call.activeRemoteVideoStreamViews && call.activeRemoteVideoStreamViews.size >= maximumNumberOfRenderers) {
                    console.error(`[App][StreamMedia][id=${stream.id}][createRenderer] reached maximum number of renderers`);
                    return;
                }
                // console.log(`[App][StreamMedia][id=${stream.id}][isAvailableChanged] isAvailable=${stream.isAvailable}`);
                createRenderer();
            } else {
                if (!stream.isAvailable) {
                    disposeRenderer();
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    const isMutedChanged = () => {
        setIsMuted(remoteParticipant && remoteParticipant.isMuted);
    };

    const isSpeakingChanged = () => {
        setIsSpeaking(remoteParticipant && remoteParticipant.isSpeaking);
    }

    const isDisplayNameChanged = () => {
        setDisplayName(remoteParticipant.displayName.trim());
    }
    /**
     * Start stream after DOM has rendered
     */
    const initializeComponent = async () => {
        // componentContainer.current.hidden = true;

        stream.on('isReceivingChanged', isReceivingChanged);

        stream.on('isAvailableChanged', isAvailableChanged);

        remoteParticipant.on('isMutedChanged', isMutedChanged);

        remoteParticipant.on('isSpeakingChanged', isSpeakingChanged);

        if (dominantSpeakerMode && dominantRemoteParticipant !== remoteParticipant) {
            return;
        }

        try {
            if (stream.isAvailable && !renderer) {
                createRenderer();
            }
        } catch (e) {
            console.error(e);
        }
    }

    useImperativeHandle(ref, () => ({
        updateReceiveStats(videoStatsReceived) {
            setVideoStats(videoStatsReceived);
        }
    }));
    // console.log(stream.isAvailable);
    // console.log(stream);
    return (
        <div>
            {/* // <Col> */}

            {/* <Row>
            */}
            {/* // <Col span={isvideoOn&& 16 }>  */}
            <div id={componentId} ref={componentContainer} >
                <div ref={videoContainer} >
                    {/* screen Sharing */}
                    {
                        videoStats &&
                        <h4 className="video-stats">
                            <VideoReceiveStats videoStats={videoStats} />
                            {displayName ? displayName : remoteParticipant.displayName ? remoteParticipant.displayName : utils.getIdentifierText(remoteParticipant.identifier)}
                        </h4>
                    }
                </div>
            </div>
            {/* // </Col> */}
            {/* // <Col span={isvideoOn && 6 } > */}
            {stream.mediaStreamType !== 'ScreenSharing' &&
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: 5,flexDirection:"column" }}>
                    {stream.isAvailable ?
                        <div id={componentId} ref={componentContainer} >
                            <div ref={videoContainer} style={{ width: isvideoOn ? 200 : 500, }}>
                                {/* vedio on  */}
                                {
                                    videoStats &&
                                    <h4 className="video-stats">
                                        <VideoReceiveStats videoStats={videoStats} />
                                    </h4>
                                }
                            </div>
                        </div>
                        :
                        <div >
                            <Avatar size={isvideoOn ? 100 : 200} style={{ border: "2px solid rgb(78, 86, 148)", background: "rgb(78, 86, 148)", borderRadius: '50%', display: 'flex', justifyContent: "center", alignItems: "center", margin: "auto", fontSize: isvideoOn ? "20px" : "70px" }} icon={<p style={{ fontSize: "70px !important", margin: "auto", marginTop: "-5px" }}>{displayName ? displayName : (remoteParticipant.displayName ? remoteParticipant.displayName : utils.getIdentifierText(remoteParticipant.identifier)).split(" ").map((item) => item.charAt(0)).join("").toUpperCase()}</p>} ></Avatar>


                        </div>
                    }
                    <h4 className="video-title" style={{ textAlign: "center", marginTop: 10 }}>
                        {displayName ? displayName : remoteParticipant.displayName ? remoteParticipant.displayName : utils.getIdentifierText(remoteParticipant.identifier)}
                    </h4>

                </div>}
            {/* // </Col> */}
            {/*
        </Row> */}
            {/* // </Col> */}
        </div>
    );
});
